import React from 'react';
import i18next from 'i18next';
import { Row, Col } from 'antd';
import ActivityTable from './ActivityTable';
import ActivityTabStyles from './styles';
import DetailSidebar from './DetailSidebar';
import CreateButton from './CreateButton';

const ActivitiesTab = () => {
  const [id, setId] = React.useState();

  const showActitivityDetail = (acitivityId) => {
    setId(acitivityId);
  };

  return (
    <ActivityTabStyles>
      <Row gutter={[20, 20]}>
        <Col xl={16} lg={24} md={24} xs={24}>
          <div className="header-title">
            <div className="title-name">{i18next.t('activity.title')}</div>
            <CreateButton />
          </div>
          <ActivityTable showActitivityDetail={showActitivityDetail} />
        </Col>
        <Col xl={8} lg={24} md={24} xs={24}>
          <DetailSidebar activityId={id} />
        </Col>
      </Row>
    </ActivityTabStyles>
  );
};

export default ActivitiesTab;
